// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/common/v1/feedback.proto (package kitecorp.transferify.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/common/v1/feedback.proto.
 */
export const file_kitecorp_transferify_common_v1_feedback: GenFile = /*@__PURE__*/
  fileDesc("Ci1raXRlY29ycC90cmFuc2ZlcmlmeS9jb21tb24vdjEvZmVlZGJhY2sucHJvdG8SHmtpdGVjb3JwLnRyYW5zZmVyaWZ5LmNvbW1vbi52MSJUChNTZW5kRmVlZGJhY2tSZXF1ZXN0EhQKB21lc3NhZ2UYASABKAlCA4ABARIaCghyZXBseV90bxgCIAEoCUIDgAEBSACIAQFCCwoJX3JlcGx5X3RvMnQKD0ZlZWRiYWNrU2VydmljZRJhCgxTZW5kRmVlZGJhY2sSMy5raXRlY29ycC50cmFuc2ZlcmlmeS5jb21tb24udjEuU2VuZEZlZWRiYWNrUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIEirUYAEI/Cixjb20ua2l0ZWNvcnAuY29udHJhY3RzLnRyYW5zZmVyaWZ5LmNvbW1vbi52MUINRmVlZGJhY2tQcm90b1ABYgZwcm90bzM", [file_google_protobuf_empty, file_kitecorp_options_v1_options]);

/**
 * One public support or contact message, which the api mails to support.
 *
 * @generated from message kitecorp.transferify.common.v1.SendFeedbackRequest
 */
export type SendFeedbackRequest = Message<"kitecorp.transferify.common.v1.SendFeedbackRequest"> & {
  /**
   * What the sender wrote, at most 512 characters. A blank text is refused. A log hides it, because it is what a person
   * wrote to support.
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * The address support should answer at. Optional: a blank value is accepted and means no reply address was given.
   * A value that is not blank must be a deliverable mailbox, because it becomes the note's Reply-To. A log hides it.
   *
   * @generated from field: optional string reply_to = 2;
   */
  replyTo?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.common.v1.SendFeedbackRequest.
 * Use `create(SendFeedbackRequestSchema)` to create a new message.
 */
export const SendFeedbackRequestSchema: GenMessage<SendFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_feedback, 0);

/**
 * The note a visitor sends to support from the feedback form (kitecorp/contracts#69). Anonymous: the form is open to
 * a visitor who has no account.
 *
 * @generated from service kitecorp.transferify.common.v1.FeedbackService
 */
export const FeedbackService: GenService<{
  /**
   * Sends one note to support. A repeat sends another note, so the call is left with unknown idempotency and a client
   * must not retry it on its own.
   *
   * @generated from rpc kitecorp.transferify.common.v1.FeedbackService.SendFeedback
   */
  sendFeedback: {
    methodKind: "unary";
    input: typeof SendFeedbackRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_common_v1_feedback, 0);

